module.exports = __webpack_public_path__ + "static/media/phone.c3a103d8.svg";